<div class="mdb-feed">
  <div class="news">
    <!-- Label -->
    <div class="label" style="cursor: pointer;" (click)="doLinkClick()">
      <!-- <img src="https://www.argonautonline.com/wp-content/uploads/2019/03/brenda-turnnidge.jpg" class="rounded-circle z-depth-1-half"> -->
      @if (image()) {
        <frontend-media-image
          [classes]="'rounded-circle z-depth-1-half'"
          [image]="image()"
          [transformations]="'w_700/'"
          >
        </frontend-media-image>
      }
      @if (!image()) {
        <img
          [src]="imageUrl"
          class="rounded-circle z-depth-1-half"
          alt="image related to the link name"
          />
      }
    </div>

    <!-- Excerpt -->
    <div class="excerpt">
      <!-- Brief -->
      <div class="">
        <a class="brief name title-link" (click)="doLinkClick()">
          @if (titleTextTranslation) {
            <span>
              <span *transloco="let t">
                <span> {{ t(titleTextTranslation) }} </span>
              </span>
            </span>
          } @else {
            {{ titleText }}
          }
        </a>
        @if (subtitleTextTranslation || subtitleText) {
          <span
            (click)="doLinkClick()"
            >
            &nbsp;&middot;&nbsp;
            @if (subtitleTextTranslation) {
              <span>
                <span *transloco="let t">
                  <span> {{ t(subtitleTextTranslation) }} </span>
                </span>
              </span>
            } @else {
              {{ subtitleText }}
            }
          </span>
        }
        @if (date) {
          <div class="date">
            @if (dateAsTimeAgo) {
              <div>7,000 years ago</div>
            }
            @if (!dateAsTimeAgo) {
              <div>{{ date | date: 'longDate' }}</div>
            }
          </div>
        }
      </div>
      <!-- Added text -->
      @if (description) {
        <div class="added-text">{{ description }}</div>
      }
    </div>
    <!-- Excerpt -->
  </div>
</div>
